import { statusDisplayNameForTrackings } from '@rsos/constants/alertStatuses';
import {
  gspx,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_CAPABILITIES,
  GPX_ROUTES,
} from '@rsos/gainsight';

const ALERT_PANE_EVENT_NAMES = {
  REMOVE_FROM_QUEUE: 'click_remove_from_queue_button',
};

export const trackRemoveFromQueue = (
  alertStatus,
  selectedAlertID,
  irpVersion,
) => {
  const displayStatus = statusDisplayNameForTrackings[alertStatus];

  gspx.trackEvent({
    name: ALERT_PANE_EVENT_NAMES.REMOVE_FROM_QUEUE,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.CALL_QUEUE,
    additionalKeys: {
      legacy_category: 'Alert',
      legacy_name: `Click remove from queue button for ${displayStatus} alert in RSP`,
      Category: 'Alert',
      'Launched date': new Date(),
      irpVersion,
    },
    entities: {
      alert_id: selectedAlertID,
    },
  });
};
